import { useState } from "react";

/** Comment/annotate panel shown inside the lightbox for sending feedback to the editing team. */
export function FeedbackPanel({ feedback, onAnnotate, onSend }) {
  const [comment, setComment] = useState("");
  const submit = async () => {
    if (!comment.trim()) return;
    await onSend(comment.trim());
    setComment("");
  };
  return (
    <div data-testid="gallery-feedback-panel">
      <div className="flex justify-between items-center gap-3">
        <div className="eyebrow">Editor feedback</div>
        <button data-testid="gallery-photo-annotate-button" onClick={onAnnotate} className="h-8 px-3 bg-[#1E2228] text-white text-[10px] uppercase tracking-[0.1em]">Annotate photo</button>
      </div>
      <div className="mt-2 max-h-24 overflow-y-auto space-y-2">
        {feedback.length ? feedback.map((item) => (
          <div key={item.id} className="text-xs border-t border-slate-200 pt-2">
            <span className="font-medium">{item.author_name}</span>
            {item.comment && <span className="text-slate-600"> · {item.comment}</span>}
            {item.strokes?.length > 0 && <span className="ml-1 text-[#B67D17]">· annotated</span>}
          </div>
        )) : <p className="text-xs text-slate-500">No feedback yet. Mark an area or add a note for your editor.</p>}
      </div>
      <div className="flex gap-2 mt-3">
        <textarea data-testid="gallery-photo-comment-input" value={comment} onChange={(event) => setComment(event.target.value)} placeholder="Add a revision note…" className="min-h-9 flex-1 resize-none border border-slate-300 bg-white px-2 py-1.5 text-xs focus:outline-none focus:border-slate-900" />
        <button data-testid="gallery-photo-comment-submit" onClick={submit} disabled={!comment.trim()} className="px-3 bg-[#1E2228] text-white text-[10px] uppercase tracking-[0.1em] disabled:opacity-40">Send</button>
      </div>
    </div>
  );
}

/** Renders any saved annotation strokes as an SVG overlay on top of the lightbox image. */
export function StrokeOverlay({ feedback }) {
  const strokes = feedback.flatMap((item) => item.strokes || []);
  if (!strokes.length) return null;
  return (
    <svg className="absolute inset-0 h-full w-full pointer-events-none" viewBox="0 0 1 1" preserveAspectRatio="none">
      {strokes.map((stroke) => {
        const key = stroke.id || `${stroke.color}-${stroke.erase}-${stroke.points?.map((point) => `${point.x}:${point.y}`).join("_")}`;
        return stroke.points?.length > 1 && (
          <polyline key={key} points={stroke.points.map((point) => `${point.x},${point.y}`).join(" ")} fill="none" stroke={stroke.erase ? "transparent" : stroke.color} strokeWidth="0.006" vectorEffect="non-scaling-stroke" strokeLinecap="round" strokeLinejoin="round" />
        );
      })}
    </svg>
  );
}
